<template>
	<div class="search-container">
		<Select v-if="tableTitles && tableTitles.length > 0" class="search-select" v-model="searchBy">
			<Option v-for="title in tableTitles" :key="title" :value="title" :label="$t(title)" />
		</Select>
		<input class="search-bar" type="text" v-model="searchTxt" :placeholder="$t('search')" />
	</div>
</template>

<script>
import Select from '@/modules/common/components/Select'
import Option from '@/modules/common/components/Option'
import { mapGetters } from 'vuex'

export default {
	name: 'TableSearch',
	props: {
		tableTitles: { type: Array, default: () => [], required: false }
	},
	created() {
		this.setDefaultSearchBy()
	},
	data() {
		return {
			searchTxt: '',
			searchBy: '',
			debounceTimeout: null // Timeout ID for manual debounce
		}
	},
	watch: {
		searchTxt(currValue) {
			// Clear the existing debounce timeout
			if (this.debounceTimeout) {
				clearTimeout(this.debounceTimeout);
			}
			// Set a new debounce timeout
			this.debounceTimeout = setTimeout(() => {
				// Emit the debounced input value and searchBy
				this.$emit('input', currValue, this.searchBy);
			}, 300); // Adjust debounce delay as needed
		},
		tableTitles() {
			this.setDefaultSearchBy()
		}
	},
	methods: {
		setDefaultSearchBy() {
			if (this.tableTitles && this.tableTitles.length > 0) {
				this.searchBy = this.tableTitles[0]
			}
		}
	},
	beforeDestroy() {
		// Clear any pending debounce timeout when the component is destroyed
		if (this.debounceTimeout) {
			clearTimeout(this.debounceTimeout);
		}
	},
	computed: {
		...mapGetters(['isRT']),
	},
	components: {
		Select,
		Option
	}
}
</script>

<style lang="scss" scoped>
@use "@/styles/mixins" as *;
@use "@/styles/vars" as *;

.search-container {
	display: flex;
	align-items: center;
	background: $light-grey;
	border-radius: 8px;
	padding: 4px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	transition: box-shadow 0.2s;

	&:focus-within {
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
		background: $white;
	}

	input {
		@include modal-input;
		margin-inline-start: 0;
		margin-bottom: 0px;
		padding: 8px 12px;
		width: 200px;
		border: none;
		background: transparent;
		font-size: $font-size-small;
		border-radius: 6px;
		transition: background 0.2s;

		&:focus {
			background: $white;
			outline: none;
		}

		&::placeholder {
			color: $dark-grey;
		}
	}

	.search-select {
		height: 36px;
		border: none;
		border-radius: 6px 0 0 6px;
		padding: 0 10px;
		margin: 0;
		width: 120px;
		background: transparent;
		font-size: $font-size-small;
		color: $black-blue;
		font-weight: $font-weight-semi-bold;

		@include rtl {
			border-radius: 0 6px 6px 0;
		}

		&:focus {
			outline: none;
		}
	}

	.search-bar {
		margin: 0;
		border-radius: 0 6px 6px 0;
		flex: 1;
		min-width: 0;

		@include rtl {
			border-radius: 6px 0 0 6px;
		}
	}
}
</style>
